import { gql } from 'graphql-request';

import { WISH_FRAGMENT } from '@graphql/fragments/wishes';

const saveWishMutation = gql`
  mutation SaveWishMutation(
    $title: String!
    $originalLang: String!
    $userGender: String
    $userAgeGroup: String
    $userResidence: String
    $lat: Float
    $lng: Float
  ) {
    createWish(
      title: $title
      originalLang: $originalLang
      userGender: $userGender
      userAgeGroup: $userAgeGroup
      userResidence: $userResidence
      lat: $lat
      lng: $lng
    ) {
      ...WishFragment
    }
  }
  ${WISH_FRAGMENT}
`;

export default saveWishMutation;
